import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "membershipForm" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { reactive, ref, computed } from "vue";
import type { Applicant } from "@/models/application";
import { FormSchema, type FieldSchema } from "@/models/form";
import BaseFormField from "@/components/shared/BaseFormField.vue";
import NextButton from "@/components/shared/NextButton.vue";
import * as yup from "yup";


export default /*@__PURE__*/_defineComponent({
  __name: 'MembershipForm',
  props: {
    disabled: { type: Boolean },
    applicant: {},
    stipId: {}
  },
  emits: ["submit"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const schema = reactive<FormSchema>({
  membership: {
    name: "membership",
    type: "checkbox",
    label: "",
    required: false,
    hideLabel: true,
  } as FieldSchema,
  memberId: {
    name: "memberId",
    type: "text",
    placeholder: "Account # or Member ID",
    label: "",
    required: true,
    hideLabel: true,
  } as FieldSchema,
});

const membership = ref<boolean | undefined>(undefined);
const memberId = ref<string | undefined>(undefined);

const applicantType = computed<string | undefined>(() => props.applicant?.applicantTypeName);

const nextButtonDisabled = computed<boolean>(() => {
  if (props.disabled || !memberId.value) {
    return true;
  }
  return false;
});

const validationSchema = yup.object({
  membership: yup.boolean().oneOf([true]).required(),
  memberId: yup.string().required(),
});

function setMembershipInfo() {
  if (props.applicant && props.applicant?.membership) {
    membership.value = props.applicant?.membership?.isMember;
    memberId.value = props.applicant?.membership?.memberId;
  }
}

function validateForm() {
  return validationSchema.isValidSync({
    memberId: memberId.value,
    membership: membership.value,
  });
}

__expose({
  memberId,
  membership,
  validateForm,
  setMembershipInfo,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BaseFormField, {
        ref: "membershipCheckboxRef",
        modelValue: membership.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((membership).value = $event)),
        schema: schema.membership,
        disabled: __props.disabled
      }, {
        label: _withCtx(() => [
          (applicantType.value === 'Primary Applicant')
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, [...(_cache[3] || (_cache[3] = [
                _createTextVNode("I am now a ", -1),
                _createElementVNode("b", { class: "underline" }, "primary member", -1),
                _createTextVNode(" of this credit union.", -1)
              ]))]))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, "I am now a member of this credit union"))
        ]),
        _: 1
      }, 8, ["modelValue", "schema", "disabled"]),
      _withDirectives(_createVNode(BaseFormField, {
        modelValue: memberId.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((memberId).value = $event)),
        schema: schema.memberId,
        disabled: __props.disabled
      }, null, 8, ["modelValue", "schema", "disabled"]), [
        [_vShow, membership.value]
      ])
    ]),
    _withDirectives(_createVNode(NextButton, {
      class: "btn-primary",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('submit', { membership: membership.value, memberId: memberId.value }))),
      text: `SAVE`,
      disabled: nextButtonDisabled.value
    }, null, 8, ["disabled"]), [
      [_vShow, membership.value]
    ])
  ], 64))
}
}

})